import { Injectable } from '@angular/core';
import { ProxyContext } from '@app/core/enums/proxy-context.enum';
import { HttpServerResponse } from '@app/core/models/response.model';
import { HttpRequestService } from '@app/core/services/http-request.service';
import { LoggerService } from '@app/core/services/logger.service';
import { Observable } from 'rxjs';
import { BlockUserCommand } from '../command/block-user.command';
import { UploadUsersCsvCommand } from '../command/up-users-csv-command';
import { UserListAllCsv } from '../command/user-lis-all-csv.command';
import { UserListAll } from '../command/user-list-all.command';
import { UserCommandAdmin } from '../command/user.command copy';
import { UserEditDetailCommand } from '../command/user-edit-detail.command';
import { UserCommand } from '../command/user.command';

const logger = new LoggerService('UsersService');

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(private readonly requestService: HttpRequestService) {}

  createUser(commandUser: UserCommandAdmin): Observable<HttpServerResponse<unknown>> {
    return this.requestService.post<HttpServerResponse<unknown>>(ProxyContext.Users, commandUser);
  }

  updateUser(commandUser: UserCommandAdmin): Observable<HttpServerResponse<unknown>> {
    return this.requestService.put<HttpServerResponse<unknown>>(ProxyContext.Users, commandUser);
  }

  getusers(commandAllUser: UserListAll): Observable<HttpServerResponse<unknown>> {
    return this.requestService.post<HttpServerResponse<unknown>>(ProxyContext.GetUsers, commandAllUser);
  }

  exportCsv(commandExport: UserListAllCsv): Observable<HttpServerResponse<unknown>> {
    return this.requestService.post<HttpServerResponse<unknown>>(ProxyContext.GetExport, commandExport);
  }

  uploadUsersCsv(commandUpload: UploadUsersCsvCommand): Observable<HttpServerResponse<unknown>> {
    return this.requestService.post<HttpServerResponse<unknown>>(ProxyContext.UploadUsersCsv, commandUpload);
  }

  getuser(commandAllUser: UserListAll): Observable<HttpServerResponse<unknown>> {
    return this.requestService.post<HttpServerResponse<unknown>>(ProxyContext.GetUsers, commandAllUser);
  }

  getUserDetail(userCommandEdit: UserEditDetailCommand) {
    return this.requestService.post<HttpServerResponse<unknown>>(ProxyContext.UserDetail, userCommandEdit);
  }

  blockUser(userCommandBlock: BlockUserCommand) {
    return this.requestService.put<HttpServerResponse<unknown>>(ProxyContext.UserBlock, userCommandBlock);
  }

  getCatalogs(): Observable<HttpServerResponse<unknown>> {
    return this.requestService.get<HttpServerResponse<unknown>>(ProxyContext.UsersCatalogs);
  }

  getUserEdit(userCommandEdit: UserEditDetailCommand) {
    return this.requestService.post<HttpServerResponse<unknown>>(ProxyContext.UserEdit, userCommandEdit);
  }

  createUserAdmin(commandUser: UserCommand): Observable<HttpServerResponse<unknown>> {
    return this.requestService.post<HttpServerResponse<unknown>>(ProxyContext.CreateAccountAdmin, commandUser);
  }
}
